import {
  apiCall,
  createIntegrationConnectionsApi,
  type ApiClientConfig,
  type IntegrationConnectionDetail,
} from "@playbookai/api-clients";

/** Account mutations currently used only by shell settings. */
export function createIntegrationConnectionSettingsApi(
  config: ApiClientConfig,
) {
  return {
    ...createIntegrationConnectionsApi(config),
    updateDescription: (
      id: string,
      description: string,
    ): Promise<IntegrationConnectionDetail> =>
      apiCall<IntegrationConnectionDetail, { description: string }>(
        config,
        "PATCH",
        `/v1/integration-connections/${id}/description`,
        { description },
      ),

    remove: (id: string): Promise<void> =>
      apiCall<void>(config, "DELETE", `/v1/integration-connections/${id}`),
  };
}
